import { Directive, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[apDisableControl]'
})
export class ApDisableControlDirective {

  @Input() set apDisableControl(condition: boolean) {
    this.setControlValue(condition, true);
  }

  private setControlValue(condition: boolean, tryAgain: boolean): void {
    const action = condition ? 'disable' : 'enable';
    if (!this.ngControl?.control || !this.ngControl.control[action]) {
      if (tryAgain) {
        // try setting again on next digest cycle
        setTimeout(() => this.setControlValue(condition, false));
      }
      return;
    }
    this.ngControl.control[action]();
  }

  constructor(private ngControl: NgControl) {
  }
}
